import i18next from 'i18next';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
// import tr from './navigation-i18n/tr';

i18next.addResourceBundle('en', 'navigation', en);
// i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);

const navigationConfigOwner = [
	{
		id: 'dashboards',
		title: 'Dashboard',
		translate: 'DASHBOARDS',
		type: 'item',
		icon: 'dashboard',
		url: '/owner/dashboard'
	},
	{
		id: 'manage-places',
		translate: 'MANAGEPLACES',
		type: 'item',
		icon: 'category',
		url: '/owner/manage-places',
		exact: true
	},
	{
		id: 'order',
		title: 'Manage Order',
		translate: 'MANAGEORDERS',
		type: 'item',
		icon: 'reorder',
		url: '/owner/manage-order',
		exact: true
	},
	{
		id: 'suggetionEdit',
		title: 'Manage Suggetions Edit',
		translate: 'SUGGETIONEDIT',
		type: 'item',
		icon: 'table_chart',
		url: '/owner/suggetion-edit'

	},
	{
		id: 'claimRequest',
		title: 'Claim Requests',
		translate: 'CLAIMREQUESTS',
		type: 'item',
		icon: 'view_list',
		url: '/owner/claim-requests'

	}
];

export default navigationConfigOwner;
